/* eslint-disable import/first */
import React, { useState } from 'react';
import menuBtn from './images/menuBtn.svg';
import favImg from './images/favourites.png';
// import { AiOutlineRight } from '@react-icons/all-files/ai/AiOutlineRight';
import { useNavigate } from '@reach/router';
import { ListItem } from '@material-ui/core';
import DrawerPwa from '../DrawerPwa';
import css from './index.module.scss';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
// import { favouriteCount } = Slices.favouriteSlice;
import { FormattedMessage, useIntl } from 'react-intl';
import { categoryMenuGA } from 'spwa-ui-library/esm/utils/helperGA';
import { selectDesktop } from 'spwa-ui-library/esm/redux/store/appSlice';
import PHBackButton from '../../components/PHBackButton';
import noImg from '../../assets/no-itm.png';
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
const { favouriteCount } = Slices.favouriteSlice;
export default function CategoryMenuButton({ categories }) {
  const navigate = useNavigate();
  const favourites = useSelector(favouriteCount);
  const [menuDrawer, setMenuDrawer] = useState(false);
  const handleDrawer = () => setMenuDrawer(!menuDrawer);
  const intl = useIntl();
  // TODO: transactions has to be parllel for changing url and closing drawer
  const handleNavigate = (url, name) => () => {
    handleDrawer();
    navigate(url);
    categoryMenuGA(name);
  };

  const isDesktop = Redux.useSelector(selectDesktop);
  // FILTERED CAT
  const filteredData = categories.filter((item) => {
    return item.parentId === 0 || !item.hasOwnProperty('parentId');
  });

  const CardGrid = () => {
    return (
      <div className={css.cardGrid}>
        {filteredData.map((cat) => {
          const { name, productCount, assets } = cat;
          const generatedPath = generateCategoryRoute({
            category: cat,
            locale: intl.locale,
          });
          const imgSrc = assets && assets[0]?.src;
          const count = cat?.id === 999 ? favourites : productCount;
          const icon = cat?.id === 999 ? favImg : imgSrc;
          const catName = cat?.id === 999 ? name?.split(' ')[1] : name;

          return (
            <ListItem
              key={cat.id}
              className={css.card}
              onClick={handleNavigate(generatedPath, name)}
            >
              <div className={css.cardImageContainer}>
                <img
                  className={css.cardImage}
                  src={icon}
                  alt={`${cat.number}`}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = noImg;
                  }}
                />
              </div>
              <div className={css.cardContent}>
                <div className={css.cardNumber}>{count}</div>
                <div className={css.cardTitle}>{catName}</div>
              </div>
            </ListItem>
          );
        })}
      </div>
    );
  };

  return (
    <>
      {!isDesktop && (
        <div className={css.menuButtonContainer} onClick={handleDrawer}>
          <div className={css.root}>
            <img src={menuBtn} alt="cart-icon" className={css.menuBtnImg} />
          </div>
          <FormattedMessage id="menu" defaultMessage="Menu" />
        </div>
      )}

      <DrawerPwa
        variant="temporary"
        anchor="bottom"
        open={menuDrawer}
        className={css.menuList}
        onClose={handleDrawer}
        hideCloseButton={true}
      >
        <div className={css.menuList}>
          <div className={css.menuWrapper}>
            <div>
              <h3>
                <FormattedMessage id="explore" defaultMessage="Explore" />
              </h3>
              <h3>
                <FormattedMessage id="Menu_Categories" defaultMessage="Menu Categories" />
              </h3>
            </div>
            <PHBackButton onclick={handleDrawer} cross={true} />
            {/* <BackButton type="cross" handleBack={handleDrawer} /> */}
          </div>
          {/* render category card */}
          <CardGrid />
        </div>
      </DrawerPwa>
    </>
  );
}
